import React from 'react';
import PropTypes from 'prop-types';
import BaseBadge from '../BaseBadge';
import styles from './styles.scss';

// 債権相殺の状態バッジ。
//   請求行: unsettled(未回収) / partially_offset(一部相殺済) / fully_offset(相殺済)
//   支払行: with_offset(相殺あり)
// status が未指定（相殺なし等）のときは何も描画しない。
// small=true で金額の上などに添える小サイズ表示にする。
const STATUS_MAP = {
  unsettled: ['未回収', 'unsettled'],
  partially_offset: ['一部相殺済', 'partial'],
  fully_offset: ['相殺済', 'full'],
  with_offset: ['相殺あり', 'with-offset'],
};

const OffsetStatusBadge = ({ status, small, className, ...rest }) => {
  const entry = status && STATUS_MAP[status];
  if (!entry) return null;

  const [label, colorKey] = entry;
  const mergedClassName = [
    styles[small ? 'size-small' : 'size-normal'],
    styles[colorKey],
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <BaseBadge className={mergedClassName} {...rest}>
      {label}
    </BaseBadge>
  );
};

OffsetStatusBadge.propTypes = {
  status: PropTypes.oneOf([
    'unsettled',
    'partially_offset',
    'fully_offset',
    'with_offset',
    null,
    undefined,
  ]),
  small: PropTypes.bool,
  className: PropTypes.string,
};

OffsetStatusBadge.defaultProps = {
  status: null,
  small: false,
  className: '',
};

export default OffsetStatusBadge;
